var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/environment.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["PRODUCTION"] = "production";
  Environment2["STAGING"] = "staging";
  Environment2["TESTING"] = "testing";
  Environment2["DEVELOPMENT"] = "development";
  return Environment2;
})(Environment || {});

// src/chains.ts
var chains_exports = {};
__export(chains_exports, {
  activeChains: () => activeChains,
  activeConfig: () => activeConfig,
  mainnets: () => mainnets,
  testnets: () => testnets
});

// ../../node_modules/@wagmi/core/dist/esm/exports/index.js
import { custom, http, webSocket } from "viem";

// src/chains.ts
import {
  testnetDeployments,
  mainnetDeployments
} from "@axis-finance/deployments";
var mainnets = mainnetDeployments.map(({ chain }) => chain);
var mainnetConfig = generateConfig(mainnetDeployments);
var testnets = testnetDeployments.map(({ chain }) => chain);
var testnetConfig = generateConfig(testnetDeployments);
var activeChains = (isTestnet) => (isTestnet ? testnets : mainnets).sort(
  (a, b) => a.name.localeCompare(b.name)
);
var activeConfig = (isTestnet) => isTestnet ? testnetConfig : mainnetConfig;
function generateConfig(deployment) {
  return deployment.reduce(
    (acc, config) => {
      const chains = acc.chains;
      const transports = acc.transports;
      const rpc = config.chain.rpcUrls.axis ?? config.chain.rpcUrls.default;
      const chain = {
        ...config.chain,
        iconBackground: "#000"
      };
      return {
        chains: [...chains, chain].sort(
          (c, other) => c.name.localeCompare(other.name)
        ),
        transports: {
          ...transports,
          [config.chain.id]: http(rpc.http[0])
        }
      };
    },
    { chains: [], transports: {} }
  );
}

// src/cloak-servers.ts
var v3URL = "https://api-testnet-v3.up.railway.app";
var cloak_servers_default = {
  development: {
    description: "Local",
    url: "http://localhost:8080"
  },
  testing: {
    description: "Testnet",
    url: v3URL
  },
  staging: {
    description: "Staging",
    url: v3URL
  },
  production: {
    description: "Mainnet",
    url: "https://api-production-8b39.up.railway.app"
  }
};

// src/ipfs-servers.ts
var ipfs_servers_default = {
  development: {
    description: "Local",
    url: "http://localhost:4000"
  },
  testing: {
    description: "Testing",
    url: "https://curator-api-staging.up.railway.app"
  },
  staging: {
    description: "Staging",
    url: "https://curator-api-staging.up.railway.app"
  },
  production: {
    description: "Production",
    url: "https://curator-api-production.up.railway.app"
  }
};

// src/utils.ts
var getCloakServer = (env) => cloak_servers_default[env ?? "production" /* PRODUCTION */];
var getCuratorServer = (env) => ipfs_servers_default[env ?? "production" /* PRODUCTION */];
export {
  Environment,
  chains_exports as chains,
  cloak_servers_default as cloakServers,
  getCloakServer,
  getCuratorServer,
  ipfs_servers_default as ipfsServers
};
//# sourceMappingURL=index.js.map